import { useEffect, useRef } from 'react'
import './Limiter.css'

interface LimiterProps {
  enabled: boolean
  gainReduction: number // in dB
  onToggle: (enabled: boolean) => void
}

export function Limiter({ enabled, gainReduction, onToggle }: LimiterProps) {
  const meterRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!meterRef.current) return
    
    // Gain reduction is negative (e.g., -3 dB means 3 dB of reduction)
    // Map to 0-100% for the meter
    const reduction = Math.abs(gainReduction)
    const maxReduction = 12 // Maximum reduction to show (12 dB)
    const percentage = Math.min(100, (reduction / maxReduction) * 100)
    
    meterRef.current.style.width = `${percentage}%`
  }, [gainReduction])

  return (
    <div className={`limiter ${enabled ? 'limiter--active' : ''}`}>
      <button
        className="limiter__button"
        onClick={() => onToggle(!enabled)}
        aria-label={enabled ? 'Disable limiter' : 'Enable limiter'}
      >
        <span className="limiter__label">Limiter</span>
        <div className="limiter__meter-container">
          <div 
            ref={meterRef}
            className="limiter__meter"
            style={{ width: enabled ? `${Math.min(100, Math.abs(gainReduction) / 12 * 100)}%` : '0%' }}
          />
        </div>
        <span className="limiter__status">{enabled ? 'ON' : 'OFF'}</span>
      </button>
    </div>
  )
}
